import { ISelectedPeriod } from '../../../models/qbr/iQbrQuarter'
import { IMappedPeriod } from '../models/mappedPeriod'

export const mapFromSelectedPeriod = (selectedPeriod: ISelectedPeriod): IMappedPeriod => {
  return {
    fYear: selectedPeriod.FYear,
    fQuarters: selectedPeriod.FQuarters.map((it) => ({
      fQuarter: it.FQuarter,
    })),
  }
}
